import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';
import { PButtonComponent } from '../../../shared/design-system/atoms/p-button/p-button.component';
import { LesMoinsEditModeComponent } from './les-moins-edit-mode/les-moins-edit-mode.component';
import { LesMoinsReadModeComponent } from './les-moins-read-mode/les-moins-read-mode.component';
import { SectionComponent } from '../section/section.component';

@Component({
  selector: 'app-les-moins',
  standalone: true,
  imports: [
    LesMoinsEditModeComponent,
    LesMoinsReadModeComponent,
    PButtonComponent,
    SectionComponent,
  ],
  templateUrl: './les-moins.component.html',
  styleUrl: './les-moins.component.scss',
})
export class LesMoinsComponent {
  @Input() drawbacks!: Report.Drawbacks;
  @Input() isLoading = false;

  drawbacksInternal!: Report.Drawbacks;

  @Output() drawbacksChanged = new EventEmitter<Report.Drawbacks>();
  @Output() drawbacksEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onDrawbacksChanged(drawbacks: Report.Drawbacks): void {
    this.drawbacksInternal = drawbacks;
  }

  onSaveSection(): void {
    this.drawbacksChanged.emit(this.drawbacksInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.drawbacksEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
